import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import React, {useState} from 'react';
import Card from "@mui/material/Card";
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid";
import { makeStyles } from '@mui/styles';
import useSignedFileUrl from "../helpers/authenticatedFile";
const useStyles = makeStyles({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 140,
    },
});

// One thumbnail's worth of signing. A gallery is a list, so this is a component
// per image rather than a hook called in a loop.
const GalleryThumbnail = ({photo, onOpen, className}) => {
    const {url} = useSignedFileUrl(photo.filePath);

    return (
        <Card>
            <CardActionArea onClick={onOpen}>
                <CardMedia
                    className={className}
                    image={url}
                    title={photo.title}
                />
            </CardActionArea>
            <CardContent>
                {photo.title}
                {photo.description}
            </CardContent>
        </Card>
    );
};

const ImagesWithLightBox = ({photos,initialIndex}) => {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false)

    // Defaults rather than an early return: the hooks below have to run on every
    // render, so bailing out before them would change the hook count.
    const list = photos || [];
    const images = list.map(p=>p.filePath);
    const [photoIndex, setPhotoIndex] = useState(initialIndex || 0)

    // The lightbox shows one photograph at a time and moves between them. Each
    // gets its own signed URL, and because the browser is caching these the
    // thumbnail already loaded is reused rather than fetched again.
    const {url: currentUrl} = useSignedFileUrl(images[photoIndex]);

    if(!photos)
    {
        return null
    }

    return (



        <div>


                    <Grid container spacing={2}>
                        {photos.filter(p=>p.filePath && p.filePath!=='').map((p,i)=><Grid  item key={`${p.filePath}-${i}`}>
                            <GalleryThumbnail
                                photo={p}
                                className={classes.media}
                                onOpen={e => {
                                    e.stopPropagation();
                                    setIsOpen(true)
                                    setPhotoIndex(i)
                                }}
                            />
                        </Grid>)}
                    </Grid>

            {isOpen && (
                <Lightbox
                    mainSrc={currentUrl}
                    nextSrc={undefined}
                    prevSrc={undefined}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() =>
                      setPhotoIndex((photoIndex + images.length - 1) % images.length)
                    }
                    onMoveNextRequest={() =>
                       setPhotoIndex((photoIndex + 1) % images.length)
                    }
                />
            )}

        </div>
    );
};

export default ImagesWithLightBox;